import { GridColumn as Column } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import { GridCellProps } from "@progress/kendo-react-grid";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import { PdsrRelationUpdateModeColumnMenu } from "./Filter/PdsrRelationUpdateModeColumnMenu";
import { RelationProjectStateColumnMenu } from "../../ColumnMenus/RelationProjectStateColumnMenu";
import { PdsrOverviewItem } from "./PdsrOverviewItem";
import { GridRowClickProps } from "../../../Layout/Grid/GridRowClickProps";
import { EnumerationCell } from "../../../Layout/Grid/Cell/Default/EnumCell";
import { relationProjectStateAsString } from "../../RelationProjectState";
import { relationUpdateModeAsString } from "../../RelationUpdateMode";
import { ContainerNetworkColumnMenu } from "./Filter/ContainerNetworkColumnMenu";
import { ScopeColumnMenu } from "../../ColumnMenus/ScopeColumnMenu";
import { ClassificationColumnMenu } from "../../ColumnMenus/ClassificationColumnMenu";
import { RoundtripColumnMenu } from "../../ColumnMenus/RoundtripColumnMenu";
import { MilkrunColumnMenu } from "../../ColumnMenus/MilkrunColumnMenu";
import { GRID_SELECTED_FIELD } from "../../../Grid/Selectable/GridSelection";
import { Rc2ColumnMenu } from "../Rc2ColumnMenu";
import { columnForField, defaultColumnWidth } from "../../../Grid/columnForField";
import { ValueOrDashCell } from "../../../Grid/ValueOrDashCell";
import { MultiSelectCheckboxProps } from "../../../Grid/Selectable/MultiSelectCheckboxProps";

export default function PdsrOverviewGridColumns({
  dataResult,
  selectedState,
  onRowClick,
}: MultiSelectCheckboxProps & GridRowClickProps) {
  const relationProjectStateEnumCell = (props: GridCellProps) => (
    <EnumerationCell {...props} mapping={relationProjectStateAsString} onRowClick={onRowClick} />
  );
  const relationUpdateModeEnumCell = (props: GridCellProps) => (
    <EnumerationCell {...props} mapping={relationUpdateModeAsString} onRowClick={onRowClick} />
  );

  return [
    <Column
      key="SelectHeader"
      field={GRID_SELECTED_FIELD}
      filterable={false}
      width="44px"
      headerSelectionValue={dataResult.data.findIndex((item) => !selectedState[item.Id]) === -1}
      locked
    />,
    columnForField<PdsrOverviewItem>("ProjectState", {
      title: "PDSR Launch Status",
      width: defaultColumnWidth,
      locked: true,
      columnMenu: RelationProjectStateColumnMenu,
      cell: relationProjectStateEnumCell,
      hideFilterCell: true,
    }),
    columnForField<PdsrOverviewItem>("ContainerNetwork", {
      title: "Container Network",
      width: defaultColumnWidth,
      locked: true,
      columnMenu: ContainerNetworkColumnMenu,
      hideFilterCell: true,
    }),
    columnForField<PdsrOverviewItem>("Pdsr", {
      title: "PDSR",
      width: defaultColumnWidth,
      locked: true,
    }),
    columnForField<PdsrOverviewItem>("PSR", {
      locked: true,
      title: "PSR",
      width: defaultColumnWidth,
    }),
    columnForField<PdsrOverviewItem>("PlantGSDB", {
      title: "Plant / ODC",
      width: defaultColumnWidth,
    }),
    columnForField<PdsrOverviewItem>("OutboundDock", {
      title: "Outbound Dock",
      width: defaultColumnWidth,
    }),
    columnForField<PdsrOverviewItem>("SupplierGSDB", {
      title: "Supplier",
      width: defaultColumnWidth,
    }),
    columnForField<PdsrOverviewItem>("State", {
      title: "PDSR Status",
      hideFilterCell: true,
      width: defaultColumnWidth,
      filter: "numeric",
      columnMenu: PdsrRelationUpdateModeColumnMenu,
      cell: relationUpdateModeEnumCell,
    }),
    columnForField<PdsrOverviewItem>("InScope", {
      title: "Scope",
      width: defaultColumnWidth,
      columnMenu: ScopeColumnMenu,
      hideFilterCell: true,
    }),
    columnForField<PdsrOverviewItem>("ImplementationDate", {
      title: "Implementation Date",
      width: "200px",
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
    }),
    columnForField<PdsrOverviewItem>("ModificationDate", {
      title: "Modification Date",
      width: defaultColumnWidth,
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
    }),
    columnForField<PdsrOverviewItem>("Classification", {
      title: "PDSR Classification",
      width: defaultColumnWidth,
      columnMenu: ClassificationColumnMenu,
      cell: ValueOrDashCell,
      hideFilterCell: true,
    }),
    columnForField<PdsrOverviewItem>("Roundtrip", {
      width: defaultColumnWidth,
      columnMenu: RoundtripColumnMenu,
      hideFilterCell: true,
    }),
    columnForField<PdsrOverviewItem>("Milkrun", {
      width: defaultColumnWidth,
      columnMenu: MilkrunColumnMenu,
      hideFilterCell: true,
    }),
    columnForField<PdsrOverviewItem>("ProposedProjectId", {
      title: "Proposed Project ID",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ActiveProjectId", {
      title: "Active Project ID",
      width: defaultColumnWidth,
      filter: "numeric",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("LaunchBatch", {
      title: "Launch Batch",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("LaunchDate", {
      title: "Launch Date",
      width: defaultColumnWidth,
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
    }),
    columnForField<PdsrOverviewItem>("ReturnLaunchDate", {
      title: "Roundtrip RT-Leg Start Date",
      width: 200,
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
    }),
    columnForField<PdsrOverviewItem>("SupplierName", {
      title: "Supplier Name",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SupplierCity", {
      title: "Supplier City",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SupplierZipCode", {
      title: "Supplier Postcode",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SupplierZipArea", {
      title: "Supplier Postcode Area",
      width: 200,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SupplierCountryName", {
      title: "Supplier Country",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("CollectionRegion", {
      title: "Collection Region",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    // PLANT
    columnForField<PdsrOverviewItem>("PlantCode", {
      title: "Plant / ODC Code",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("PlantName", {
      title: "Plant / ODC Name",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("PlantCity", {
      title: "Plant / ODC City",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("PlantCountryName", {
      title: "Plant / ODC Country",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("RouteIntoFirstOdc", {
      title: "Plant / EPC Outbound Trunk",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdcCarrierGsdb", {
      title: "Plant / EPC Outbound Carrier GSDB",
      width: "300px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdcCarrierBranch", {
      title: "Plant / EPC Outbound Carrier Name",
      width: "300px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("CollectionEtaPlantOrOdc", {
      title: "Plant / EPC Outbound ETA",
      width: "225px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("CollectionEtdPlantOrOdc", {
      title: "Plant / EPC Outbound ETD",
      width: "225px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdcTrainFerry", {
      title: "Plant / EPC Outbound Train / Ferry",
      width: "300px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdc", {
      title: "1st ODC",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdcArrivalDay", {
      title: "1st ODC Arrival Day",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdcEta", {
      title: "1st ODC Arrival ETA",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdcHandlingTime", {
      title: "1st ODC Handling Time",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdcOutboundDay", {
      title: "1st ODC Outbound Day",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("RouteIntoSecondOdc", {
      title: "1st ODC Outbound Trunk",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdcCarrierGsdb", {
      title: "1st ODC Outbound Carrier GSDB",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdcCarrierBranch", {
      title: "1st ODC Outbound Carrier Name",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("CollectionEtaFirstOdc", {
      title: "1st ODC Outbound ETA",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("FirstOdcEtd", {
      title: "1st ODC Outbound ETD",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdcTrainFerry", {
      title: "1st ODC Outbound Train / Ferry",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdc", {
      title: "2nd ODC",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdcArrivalDay", {
      title: "2nd ODC Arrival Day",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdcEta", {
      title: "2nd ODC Arrival ETA",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdcHandlingTime", {
      title: "2nd ODC Handling Time",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdcOutboundDay", {
      title: "2nd ODC Outbound Day",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("RouteInto3rdOdc", {
      title: "2nd ODC Outbound Trunk",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ThirdOdcCarrierGsdb", {
      title: "2nd ODC Outbound Carrier GSDB",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ThirdOdcCarrierBranch", {
      title: "2nd ODC Outbound Carrier Name",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("CollectionEtaSecondOdc", {
      title: "2nd ODC Outbound ETA",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("SecondOdcEtd", {
      title: "2nd ODC Outbound ETD",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ThirdOdcTrainFerry", {
      title: "2nd ODC Outbound Train / Ferry",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ThirdOdc", {
      title: "3rd ODC",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ThirdOdcArrivalDay", {
      title: "3rd ODC Arrival Day",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ThirdOdcEta", {
      title: "3rd ODC Arrival ETA",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ThirdOdcHandlingTime", {
      title: "3rd ODC Handling Time",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ThirdOdcOutboundDay", {
      title: "3rd ODC Outbound Day",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("DeliveryToSupplierRoute", {
      title: "Delivery to Supplier Route",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("DeliveryToSupplierCarrierGsdb", {
      title: "Delivery to Supplier Carrier GSDB",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("DeliveryToSupplierCarrierBranch", {
      title: "Delivery to Supplier Carrier Name",
      width: "300px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("CollectionEtaDeliveryToSupplier", {
      title: "Delivery to Supplier Collection ETA",
      width: "280px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("CollectionEtdDeliveryToSupplier", {
      title: "Delivery to Supplier Collection ETD",
      width: "280px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("DeliveryToSupplierArrivalDay", {
      title: "Supplier Arrival Day (Full Day TT)",
      width: "260px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("EtaAtSupplier", {
      title: "ETA at Supplier",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("DeliveryToSupplierTrainFerry", {
      title: "Delivery to Supplier Train / Ferry",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("EngineeredSf", {
      title: "Engineered SF",
      width: "150px",
      filter: "numeric",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("LtlKmFromLastOdcOrPlant", {
      title: "LTL km from last ODC / Plant",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("TotalPdsrKm", {
      title: "Total PDSR km",
      width: "150px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("Rc2Flag", {
      title: "Limited Pool Size",
      width: defaultColumnWidth,
      columnMenu: Rc2ColumnMenu,
      cell: ValueOrDashCell,
      hideFilterCell: true,
    }),
    columnForField<PdsrOverviewItem>("ActiveContainerTypes", {
      title: "Active Container Types",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ExpiredContainerTypes", {
      title: "Expired Container Types",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<PdsrOverviewItem>("ExpiredManualContainerTypes", {
      title: "Expired Manual Container Types",
      width: "260px",
      cell: ValueOrDashCell,
    }),
  ];
}
